import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Icon } from '@mui/material';

const NoActiveOrganisatieMessage: React.FC = () => {
 
  return (
    <>
      <div className="paper-content">
        <p className='center'>
          Er is nog geen actieve organisatie gekozen.<br/>
          Gebruik menuitem <IconButton size="large"><Icon>domain</Icon></IconButton> om een organisatie te kiezen.<br/>
          Ga naar mijn/organisaties <Link to="/mijn/organisaties">mijn organisaties</Link>.
        </p>
      </div>
    </>
  );
};

export default NoActiveOrganisatieMessage;
